import * as Yup from 'yup';
import { SarlaftInsurance } from '../../../../../../shared/types/modules/sarlaft';

export const initialValues: SarlaftInsurance = {
    complaintsLastTwoYears: false,
};

export const validationSchema = Yup.object({});
